module.exports = __webpack_public_path__ + "img/logo.e215a32a.png";